/**
 * Scroll reveal — `[data-reveal]` elements get .is-revealed once their top has
 * come 15% above the viewport bottom, or once they are anywhere above that
 * line: the observed root reaches far up, so a jump or a restored scroll
 * position that skips past them in one frame does not leave them hidden.
 *
 * <li data-reveal>…</li>
 *
 * The module only flips the state; what the reveal looks like is up to the
 * component's CSS (the timeline in 85_blocks.sass). The hidden starting state
 * hangs on .is-reveal-pending, which only this module sets — without JS
 * nothing is hidden. Elements revealed in the same frame (a tall viewport
 * shows several at once) get `--reveal-stagger` 0, 1, 2 … in DOM order, so
 * the CSS can play them one after the other.
 */
const items = document.querySelectorAll('[data-reveal]')

if (items.length && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries
        .filter((entry) => entry.isIntersecting)
        .forEach(({ target }, index) => {
          target.style.setProperty('--reveal-stagger', index)
          target.classList.replace('is-reveal-pending', 'is-revealed')
          observer.unobserve(target)
        })
    },
    { rootMargin: '100000px 0px -15% 0px' }
  )

  items.forEach((item) => {
    item.classList.add('is-reveal-pending')
    observer.observe(item)
  })
}
